// extracted by mini-css-extract-plugin
module.exports = {"StyledContentColumns":"HfmtT","StyledContentColumns__single":"_8aUDJ","StyledContentColumns_Column":"ibbfs"};